import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { combineReducers } from "redux";
import snackbarReducer from "utils/snack_bar/store/reducer";
import { loadErrorMessages, loadDevMessages } from "@apollo/client/dev";
import { configureStore } from "@reduxjs/toolkit";
import { Provider } from "react-redux";
import loginReducer from "modules/auth/login/store/reducer";
import throttle from "lodash.throttle";
import logoutReducer from "modules/auth/logout/store/reducer";
import fetchPackagesReducer from "modules/membership_plan/commercial_membership_plan/packages/store/reducer";
import getModulesReducer from "modules/modules/store/reducer";
import fetchMembershipDurationReducer from "modules/membership_plan/commercial_membership_plan/membership_duration/store/reducer";
import VideoSeriesReducer from "modules/video/series/store/reducer";
import VideoSeasonsReducer from "modules/video/season/store/reducer";
import VideoEpisodeReducer from "modules/video/episode/store/reducer";
import videoGroupsReducer from "modules/video/group/store/reducer";
import VideoDetailsReducer from "modules/video/video_detail/store/reducer";
import VideoCategoriesReducer from "modules/video/category/store/reducer";
import fetchCouponReducer from "modules/cupon/store/reducer";
import fetchRolesReducer from "modules/auth/role/store/reducer";
import UserReducer from "modules/auth/users/store/reducer";
import QuestionssReducer from "modules/video/question_and_answer/store/reducer";
import DcddMembershipReducer from "modules/membership_plan/dcdd_membership_plan/dcdd_membership/store/reducer";
import ReadingMaterialReducer from "modules/video/reading_material/store/reducer";
import DcddUserReducer from "modules/user_management/dcdd_user/users/state/reducer";
import CommercialUserReducer from "modules/user_management/commercial_user/user/state/reducer";
import fetchMembershipPlanReducer from "modules/membership_plan/commercial_membership_plan/commercial_membership/store/reducer";
import fetchPaymentReducer from "modules/report/payment_responses/store/reducer";
import emailogs from "modules/email_log/store/reducer";
import fetchFaq from "modules/faq/state/reducer";
import fetchPermission from "modules/auth/permission/store/reducer";
import fetchFeaturedAdsReducer from "modules/featured_ads/state/reducer";
import dcddTotalDataReducer from "modules/report/dcdd_report/state/reducer";
import commercialTotalDataReducer from "modules/report/commercial_report/state/reducer";
import avatarImageReducer from "modules/avater/store/reducer";
import cheyCheyImageReducer from "modules/chey_chey/store/reducer";
import fetchSpecialOfferReducer from "modules/special_offer/state/reducer";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
const rootReducer = combineReducers({
  snackbar: snackbarReducer,
  //user or auth
  auth: loginReducer,
  logout: logoutReducer,
  users: UserReducer,
  dcddUser:DcddUserReducer,
  //module
  module: getModulesReducer,
  //roles
  roles: fetchRolesReducer,
  // permission
  permission: fetchPermission,
  // faq
  featuredAds: fetchFeaturedAdsReducer,
  // faq
  faq: fetchFaq,
  //packages
  packages: fetchPackagesReducer,
  membershipPlan: fetchMembershipPlanReducer,
  membershipDuration: fetchMembershipDurationReducer,
  //dcdd membership
  dcddMembership: DcddMembershipReducer,
  //commercial user
  commercialUser: CommercialUserReducer,
  //coupon
  coupon: fetchCouponReducer,
  //videos
  videoGroups: videoGroupsReducer,
  videoCategories: VideoCategoriesReducer,
  videoSeries: VideoSeriesReducer,
  videoSeasons: VideoSeasonsReducer,
  videoEpisodes: VideoEpisodeReducer,
  videoDetails: VideoDetailsReducer,
  //questionnaire
  questions: QuestionssReducer,
  readingMaterial: ReadingMaterialReducer,
  paymentResponse: fetchPaymentReducer,
  //emailLogs
  email: emailogs,
  dcddTotalDataReducer: dcddTotalDataReducer,
  commercialTotalDataReducer:commercialTotalDataReducer,
  avatarImageReducer:avatarImageReducer,
  cheyCheyImageReducer:cheyCheyImageReducer,
  fetchSpecialOfferReducer:fetchSpecialOfferReducer
});

loadDevMessages();
loadErrorMessages();

const loadState = () => {
  try {
    const serializedState = sessionStorage.getItem("state");
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (e) {
    return undefined;
  }
};

const saveState = (state: any) => {
  try {
    let serializedState = JSON.stringify(state);
    sessionStorage.setItem("state", serializedState);
  } catch (err) {
    // Silently fail if sessionStorage is unavailable
  }
};

const preloadedState = loadState();
export const store = configureStore({
  reducer: rootReducer,
  preloadedState,
  // middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

store.subscribe(
  throttle(() => {
    saveState(store.getState());
  }, 500)
);

root.render(
  <React.StrictMode>
    <Suspense>
      <Provider store={store}>
        <App />
      </Provider>
    </Suspense>
  </React.StrictMode>
);
reportWebVitals();
